import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faClose,
	faLocationDot,
	faScaleBalanced,
	faBuilding,
	faChartPie,
	faChevronRight,
	faChevronLeft,
	faTrashAlt,
	faCirclePlus,
} from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'

library.add(
	faClose,
	faLocationDot,
	faScaleBalanced,
	faBuilding,
	faChartPie,
	faChevronRight,
	faChevronLeft,
	faTrashAlt,
	faCirclePlus,
)

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class CreateProposalModal extends Vue {
	loading = false

	form = {
		company_name: '',
		company_contact: '',
		terms: [] as any[],
		pricing: [] as any[],
		socials: [] as any[],
		proposals_subjects: [] as any[],
		subject: null as any,
	}

	options = {
		subjects: [],
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	resetForm() {
		const terms = [
			{
				text: 'Pró-labore inicial: 3 parcelas mensais no valor de R$ 6.000,00 por ação distribuída',
				id: 1,
			},
			{
				text: 'Valores antecipados serão descontados dos honorários de êxito.',
				id: 2,
			},
			{
				text: 'Tributos: Os honorários de Pró-labore e êxito são líquidos de impostos.',
				id: 3,
			},
			{
				text: 'Os honorários de êxito ficam limitados ao valor de R$ 350.000,00 (trezentos e cinquenta mil reais) por ação.',
				id: 4,
			},
		]

		const pricing = [
			{
				text: 'Até R$ 4 milhões',
				value: '6%',
				id: 1,
			},
			{
				text: 'De R$ 4,001 milhões a R$ 8 milhões',
				value: '5%',
				id: 2,
			},
			{
				text: 'Acima de R$ 8 milhões',
				value: '4%',
				id: 3,
			},
		]

		this.form.company_name = ''
		this.form.company_contact = ''
		this.form.terms.length = 0
		this.form.terms.push(...terms)
		this.form.pricing.length = 0
		this.form.pricing.push(...pricing)
		this.form.socials.length = 0
		this.form.proposals_subjects.length = 0
		this.form.subject = null
	}

	setForm(proposal) {
		this.form.company_name = proposal.company_name
		this.form.company_contact = proposal.company_contact

		// terms, pricing, socials vem em forma de objeto do banco
		const terms = JSON.parse(proposal.terms)
		this.form.terms = terms.items

		this.form.pricing = JSON.parse(proposal.pricing)
		//this.form.socials.push(...proposal.socials)
		this.form.proposals_subjects = proposal.proposals_subjects.map(
			(subject) => {
				return {
					calc_subjects_id: subject.calc_subject.id,
					text: subject.text,
					title: subject.title,
				}
			},
		)
		this.form.subject = null
	}

	addSubject() {
		if (!this.form.subject) return

		const found = this.form.proposals_subjects.find(
			(subject) => subject.calc_subject_id === this.form.subject.id!,
		)

		if (found) return

		this.form.proposals_subjects.push({
			calc_subjects_id: this.form.subject.id!,
			text: this.form.subject.proposal_text || '',
			title: this.form.subject.name!,
		})

		this.form.subject = null
	}

	removeSubject(index) {
		this.form.proposals_subjects.splice(index, 1)
	}

	addTermsItem() {
		const lastId = this.form.terms[this.form.terms.length - 1]?.id || 1
		this.form.terms.push({ text: '', id: lastId + 1 })
	}

	removeTermsItem(index) {
		this.form.terms.splice(index, 1)
	}

	addPricingItem() {
		const lastId = this.form.pricing[this.form.pricing.length - 1]?.id || 1
		this.form.pricing.push({ text: '', value: '', id: lastId + 1 })
	}

	removePricingItem(index) {
		this.form.pricing.splice(index, 1)
	}

	addSocialsItem() {
		const lastId = this.form.socials[this.form.socials.length - 1]?.id || 1
		this.form.socials.push({ text: '', id: lastId + 1 })
	}

	removeSocialsItem(index) {
		this.form.socials.splice(index, 1)
	}

	async submit() {
		this.loading = true
		const res = await api.post('/api/proposals', this.form)
		this.loading = false

		if (res.ok) {
			this.$bvToast.toast('Proposta Criada!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			this.close()
			this.$emit('created')

			const api = process.env.VUE_APP_URL || 'http://192.168.10.10:8734'
			window.open(
				`/api/my-account/proposals/${res.data.id}/pdf`,
				'_blank',
			)
		} else {
			this.$bvToast.toast('Não foi possível criar proposta: ' + res.msg, {
				title: 'Erro!',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}

	close() {
		this.$bvModal.hide('create-proposal')
		this.resetForm()
	}

	async mounted() {
		this.resetForm()
		const res = await api.get('/api/calc/subjects')
		this.options.subjects = res.data
	}
}
